import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Button, Card, Form } from 'react-bootstrap';
import { useAuth } from '../auth';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // Where the visitor was headed before we bounced them here (set by <AuthToBook> and
  // <ProtectedRoute>). If present, it wins over the role-based default landing spot.
  const from = location.state?.from || null;
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const demo = (searchParams.get('demo') || '').toLowerCase();
    if (demo === 'owner') setForm({ email: 'owner@rentalverse.demo', password: 'Demo@1234' });
    else if (demo === 'admin') setForm({ email: 'admin@rentalverse.demo', password: 'Demo@1234' });
    else if (demo === 'customer' || demo === '1' || demo === 'true') {
      setForm({ email: 'customer@rentalverse.demo', password: 'Demo@1234' });
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const user = await login(form.email, form.password);
      // Came here mid-task (e.g. "Log in to request a booking") - go back to finish it.
      if (from) {
        navigate(from, { replace: true });
        return;
      }
      // Otherwise: automatic, hassle-free landing spot per role. The 3 finance_* roles land on
      // /admin too (AdminDashboard's Finance tab - see App.js's route guard), same as admin.
      if (['admin', 'finance_employee', 'finance_lead', 'finance_manager'].includes(user.role)) navigate('/admin');
      else if (user.role === 'owner') navigate('/owner');
      else if (user.role === 'delivery') navigate('/delivery');
      else navigate('/my-bookings');
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to log in');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="mx-auto" style={{ maxWidth: 420 }}>
      <Card.Body>
        <Card.Title as="h3" className="mb-3">
          Log in
        </Card.Title>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
            />
          </Form.Group>
          <Button type="submit" disabled={submitting} className="w-100">
            {submitting ? 'Logging in…' : 'Log in'}
          </Button>
        </Form>
        <p className="text-center mt-3 mb-0">
          New here? <Link to="/signup" state={from ? { from } : undefined}>Create an account</Link>
        </p>
      </Card.Body>
    </Card>
  );
}
